export const ALL_PERMISSIONS = {
  userCanViewDashboard: "VIEW_DASHBOARD",
  userCanEditTransactionNote: "EDIT_TRANSACTION_NOTE",
  userCanSendTransactionReceipt: "SEND_TRANSACTION_RECEIPT",
  userCanUpdateOwnUserProfile: "UPDATE_OWN_USER_PROFILE",
  userCanSearchTransactions: "SEARCH_TRANSACTIONS",
  userCanViewTransactionDetails: "VIEW_TRANSACTION_DETAILS",
  userCanVoidTransaction: "VOID_TRANSACTION",
  userCanRefundTransaction: "REFUND_TRANSACTION",
  userCanActivateUser: "ACTIVATE_USER",
  userCanDeactivateUser: "DEACTIVATE_USER",
  userCanGrantAgencyMembershipToUser: "GRANT_AGENCY_MEMBERSHIP_TO_USER",
  userCanRevokeAgencyMembershipFromUser: "REVOKE_AGENCY_MEMBERSHIP_FROM_USER",
  userCanViewClientsList: "LIST_CLIENTS",
  userCanViewAdministeredUsers: "LIST_ADMINISTERED_USERS",
  userCanSearchAgencies: "SEARCH_AGENCIES",
};

export const ROLES = {
  ADMIN: "CLIENT_ADMIN",
};
